import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAPIResponse } from '../../shared/models/IApiResponse';
import { IGlimpseNewReport } from '../../customer-shared/models/IGlimpseNewReport';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, map } from 'rxjs/operators';
import { IGlimpseReport } from '../../customer-shared/models/IGlimpseReport';

@Injectable({
  providedIn: 'root',
})
export class AuditsService {
  constructor(private http: HttpClient) {}

  getNewReports(locationId: number) {
    return this.http
      .get<IAPIResponse<IGlimpseNewReport[]>>(`${environment.apiBase}/v1.0/reports/new/${locationId}`)
      .pipe(map(res => res.data));
  }

  getNewMonthlyReports(locationId: number) {
    return this.http
      .get<IAPIResponse<IGlimpseNewReport[]>>(`${environment.apiBase}/v1.0/reports/new-monthly/${locationId}`)
      .pipe(map(res => res.data));
  }
}
